module.exports = __webpack_public_path__ + "img/story023.52efe28a.png";